const ACHIEVEMENTS = [
  { id: 'regular-player', title: 'İstikrarlı Oyuncu', description: '25 oyun bitir', metric: 'totalGames', target: 25 },
  { id: 'win-streak', title: 'Galibiyet Serisi', description: 'Art arda 5 oyun kazan', metric: 'bestWinStreak', target: 5 },
  { id: 'master-player', title: 'Usta Oyuncu', description: '50 oyun kazan', metric: 'wins', target: 50 },
  { id: 'big-score', title: 'Büyük Skor', description: 'Bir maçta en az 100 puan kazan', metric: 'bestScore', target: 100 },
  { id: 'board-master', title: 'Tahta Ustası', description: '5×5, 7×7 ve 9×9 tahtalarda kazan. Eski 7/9/10 başarısı da korunur.', boardWins: [5, 7, 9] },
  ...[5, 7, 9, 10].map(size => ({ id: `word-master-${size}`, title: size===10?'10 Harf Rekoru · Eski tahta':`${size} Harf Ustası`, description: `Bir maçın sonunda en çok ${size} harfli yatay/dikey kelime rekorunu tut`, recordSize: size })),
];

function achievementProgress(item, stats = {}, records = {}) {
  if (item.recordSize) {
    const value = Number(stats.fullWordRecords?.[item.recordSize]) || 0;
    const target = Number(records[item.recordSize]?.count) || 0;
    return { value, target, earned: value > 0 && value === target };
  }
  if (item.boardWins) {
    const value = item.boardWins.filter(size => stats.boardWins?.[size]).length;
    const legacy=item.id==='board-master'&&[7,9,10].every(size=>stats.boardWins?.[size]);
    return { value:legacy?item.boardWins.length:value, target: item.boardWins.length, earned: value === item.boardWins.length || legacy };
  }
  const value = Number(stats[item.metric]) || 0;
  return { value, target: item.target, earned: value >= item.target };
}

function unlockedBetween(before, after) {
  return ACHIEVEMENTS.filter(item => !item.recordSize && !item.boardWins && !achievementProgress(item, before).earned && achievementProgress(item, after).earned);
}
module.exports = { ACHIEVEMENTS, achievementProgress, unlockedBetween };
